import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-onboard-question-detail',
  templateUrl: './onboard-question-detail.component.html',
  styleUrls: ['./onboard-question-detail.component.scss']
})
export class OnboardQuestionDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
